import { Box, Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { paymentVerifyApi } from "../services/packagesApi"
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import createCache from "@emotion/cache";
import "./stylePrivacyPolicy.css"
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";


const cacheRTL = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const PrivacyPolicy = () => {
  const [resCode, setResCode] = useState("wait");
  const [saleReferenceId, setSaleReferenceId] = useState(null);
  const [lighteMode, setLightMode] = useState(false);

  const controlThemeMode = () => {
    setLightMode(!lighteMode)
    localStorage.setItem("themeMode", !lighteMode);
  }



  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode) {
        setLightMode(themeMode);
      } else {
        console.log("Theme Mode is Dark");
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }

  useEffect(() => {
    CheckInitialMode();
  }, []);

  return (
    <CacheProvider value={cacheRTL}>
      <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
        <HelmetProvider>
          <Helmet>
            <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
          </Helmet>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              minHeight: '100vh',
              backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
            }}
          >
            <MaterialUISwitch

              onClick={controlThemeMode}
              sx={{ m: 1, position: "fixed", top: "10px", left: "10px" }}
              checked={!lighteMode}
            />
            <Typography className='umlangtitle'>
              UMLANG
            </Typography>
            <Box
              sx={{
                // textAlign: 'center',
                border: 5,
                borderColor: 'secondary.main',
                p: 3,
                mx: 10,
                borderRadius: "2%",
                background: "#7d7aaf"
              }}
            >

              <Typography>

                به سایت اوملنگ خوش آمدید؛
                <br />
                تمامی افرادی که به صورت مستقیم یا غیر مستقیم شامل مهمانان یا افراد ثبت نام کرده که از محتوای وب سایت اوملنگ استفاده می‌کنند، باید شرایط زیر را به صورت کامل بپذیرند. محتوای این صفحه و شرایط و ضوابط استفاده از وب سایت ممکن است در هر زمانی بدون اطلاع به کاربران تغییر کند. تمامی تغییرات اعمال شده در این صفحه قابل مشاهده خواهند بود.
                <br />
                دسترسی به وب سایت
                <br />
                بخشی از خدمات و محتوای این وب سایت که به صورت کامل رایگان بوده و در دسترس همه عموم قرار دارد. این گونه خدمات درصورت عدم دسترسی به این وب سایت به هر دلیلی یا قطع خدمات و مسدود شدن محتوای وب سایت، ما هیچ گونه مسئولیتی را قبول نخواهیم کرد. اگرچه محتوای این وب سایت بسیار قابل اعتماد است، ما ضمانت نمی‌کنیم که این وب سایت و محتوای آن، بدون اشکال و خطا باشد. بنابراین در استفاده از محتوای آن هیچ گونه مسئولیتی در هیچ موردی را قبول نخواهیم کرد. تمامی لینک‌های خارجی داده شده تنها برای اطلاع رسانی بوده و این وب سایت هیچ گونه مسئولیتی را درقبال محتوای آن‌ها ندارد.
                <br />
                مالکیت حقوقی
                <br />
                تمامی حقوق مادی و معنوی این وب سایت و محتوای آن از جمله حقوق کپی رایت نزد ما محفوظ است. هیچ یک از محتوای ما کپی برداری از منابع داخلی و فارسی نبوده و اکثر محتوای موجود به صورت اختصاصی تولید شده اند. به دلیل آن که محتوای موجود به صورت اختصاصی تولید می‌شوند، کپی برداری از آن غیر مجاز است. همچنین استفاده غیر شخصی از محتوای وب سایت نیز درصورت عدم داشتن اجازه کافی، ممنوع است. در غیر این صورت ما این اجازه را به خود می‌دهیم تا از فرد و وب سایت کپی کننده شکایت کرده و یا وب سایت خاطی را از لیست نتایج موتورهای جستجوگر معروف از جمله گوگل و بینگ حذف نمائیم.
                <br />
                حریم شخصی افراد
                <br />
                هیچ یک از اطلاعات وارد شده حساس در این وب سایت (از جمله ایمیل‌ها، شماره تلفن و موبایل‌ها و سایر موارد) منتشر نخواهد شد و به صورت کامل نزد ما محفوظ خواهد ماند. برخی از اطلاعات پایه‌ای شما مانند آدرس IP توسط سرویس‌های آمارگیری (ازجمله Google Webmasters و Google Analytics) جمع آوری خواهند شد که فقط و فقط برای افزایش رضایت کاربران از این وب سایت استفاده قرار خواهند گرفت. اطلاعات غیرحساس مانند نام، نام خانوادگی ممکن است در قسمت‌های مختلف سایت از جمله قسمت نظرات به صورت عمومی نشان داده شوند.

                <br />
                شرایط و ضوابط استفاده از برنامه اوملنگ
                <br />
                استفاده از برنامه اینترنتی اوملنگ به معنی توافق کامل شما با شرایط و ضوابط ذیل تلقی می گردد:
                <br />
                1- خرید خدمات از برنامه اینترنتی اوملنگ بر مبنای قوانین و آئین نامه های موجود در تجارت الکترونیک و با رعایت کامل تمام قوانین جمهوری اسلامی ایران صورت می پذیرد.
                <br />
                2- محصولات این سایت براى استفاده شخصی و غیر تجارى مشتریان عرضه شده است و مالکیت معنوی اطلاعات موجود در آن متعلق به این برنامه بوده و هر گونه سوء استفاده از این اطلاعات پیگرد قانونی دارد. استفاده غیرتجاری از محتویات سایت با ذکر منبع بلامانع است و اگر مایلید از اطلاعات موجود در سایت جهت مقاصد تجاری استفاده نمایید باید از طریق پست الکترونیکی info.umlag@gmail.com درخواست خود را ارسال نموده و اجازه نامه کتبی اخذ نمایید.
                <br />
                3- کاربران هنگام سفارش  ملزم می باشند اطلاعات صحیح کامل را در پایگاه درج کنند. بدیهی است کاستی یا نادرستی اطلاعات، مانع تکمیل مراحل سفارش خواهد شد.
                <br />
                4- برنامه اینترنتی اوملنگ هیچ گونه مسئولیتی را در مورد کارکرد ناقص سایت که می تواند ناشی از عوامل خارج از حوزه مدیریت این سایت باشد (همانند نقص اینترنت، مسائل مخابراتی، تجهیزات سخت افزاری و غیره) نمی پذیرد.
                <br />
                5- ارتباط برنامه اینترنتی اوملنگ با کاربران از طریق ایمیل و تماس و پیامک برقرار می گردد و فقط با استفاده از اطلاعاتی که کاربران در سایت درج کرده اند (همانند نشانی، تلفن و …) صورت می پذیرد.
                <br />
                6- برنامه اینترنتی اوملنگ به هیچ وجه اطلاعات منحصر بفرد کاربران را به اشخاص و طرفین غیر، واگذار نخواهد کرد و ضمنا با استفاده از آخرین فن آوری ها متعهد است حتی المقدور از حریم شخصی کاربران دفاع کند.
                <br />
                7- هدف از ایجاد بخش نظرات در برنامه اینترنتی آملنگ، اشتراک گذاری تجربه کار با برنامه است که به فروش می رسد. بخش نظرات برنامه اینترنتی اوملنگ با دیگر سایت ها و شبکه های اجتماعی متفاوت است. در این بخش، هر کاربر مجاز است در چهارچوب شرایط و قوانین سایت، نظرات خود را به اشتراک بگذارد . برنامه اینترنتی اوملنگ در قبال درستی یا نادرستی نظرات منتشرشده در این قسمت، هیچگونه مسئولیتی ندارد و نمایش نظرات کاربران در سایت به هیچ وجه به معنی تایید فنی برنامه اینترنتی اوملنگ درباره محتویات نظر نیست.
                <br />
                شرایط و ضوابط خدمات فروش خدمات
                <br />
                از نظر حقوقی، در معاملات برنامه اینترنتی آملنگ، سایت umlang.com به عنوان فروشنده و کاربر اینترنتی سفارش دهنده به عنوان خریدار تلقی می شوند.
                <br />
                1- فروش بر مبنای نوع و مقداری صورت می گیرد که خریدار آن را در برنامه اینترنتی اوملنگ درج نموده است.
                <br />
                2- فروشنده ثبت سفارش و مشخصات سفارش را به اطلاع خریدار می رساند.
                <br />
                3- ارزش خدمات یا کالاهای سفارش داده شده طبق فهرست قیمت سایت محاسبه شده و شامل کلیه مالیات ها و عوارض فروش خواهد بود. تنها مبلغی که در بعضی از موارد، به ارزش خدمات اضافه می شود.
                <br />
                4- پرداخت وجه کالای خریداری شده فقط از طریق پرداخت از طریق درگاه اینترنتی امکان پذیر است و انواع دیگر پرداخت اعم از پرداخت در محل یا کارت به کارت و …. امکان پذیر نمی باشد.
                <br />
                5- در صورت بروز مشکل در پردازش نهایی سبد خرید مانند حذف کالا یا خدمات و یا انصراف خریدار، مبلغ پرداخت شده طی 24 الی 48 ساعت کاری به حساب خریدار واریز خواهد شد.
                <br />


              </Typography>
              <Link sx={{ m: 3 }} to="/" style={{ textDecoration: "none" }}>
                <Button sx={{ m: 1, mt: 3 }} variant="contained">
                  برگشت به صفحه اصلی
                </Button>
              </Link>
            </Box>
          </Box>

        </HelmetProvider>
      </ThemeProvider>
    </CacheProvider>

  );
};

export default PrivacyPolicy;
